import './App.css';
import IconRow from "./components/iconRow/IconRow"; 



function adjustScaling() {
  let userAgent = navigator.userAgent.toLowerCase();
  let scaleFactor = 1;

  if (userAgent.includes("chrome") ) {
      scaleFactor = 1; 
  } else if (userAgent.includes("firefox")) {
      scaleFactor = 0.48; 
  } else if (userAgent.includes("safari")) {
      scaleFactor = 1;
  }
  document.body.style.transform = `scale(${scaleFactor})`;
  document.body.style.transformOrigin = "top left";
  document.body.style.width = `${100 / scaleFactor}%`; // Ensure content doesn't overflow
}

window.onload = adjustScaling;
window.onresize = adjustScaling;

function App() {

  return (
      <IconRow />
  );
}

export default App;
